import { Reducer } from 'redux';
import * as Bixby from './../../core';
import {
  ClientState,
  ClientActionTypes,
  CLIENTS_LOADING,
  CLIENTS_SUCCESS,
  CLIENTS_FAILURE,
  ClientUpdateType,
  CLIENT_SUCCESS,
  CLIENT_FAILURE,
  CREATE_CLIENT,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  CLIENT_UPDATE_SUCCESS,
  CLIENT_UPDATE_FAILURE,
  CLIENT_USERS_LOADING,
  CLIENT_USERS_SUCCESS,
  CLIENT_USERS_FAILURE,
} from './types';

import { LOGIN_CLEAR_PRELOADED_DATA } from '$/store/login/types';

const initialState: ClientState = {
  isLoading: false,
  error: undefined,
  clients: [],
  currentClient: undefined,
  isCreating: false,
  createError: undefined,
  clientUsersLoading: false,
  clientUsers: undefined,
};

const clientsReducer: Reducer<ClientState> = (state = initialState, action: ClientActionTypes): ClientState => {
  switch (action.type) {
    case LOGIN_CLEAR_PRELOADED_DATA:
      return initialState;
    case CLIENTS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case CLIENTS_SUCCESS:
      const keyofName: keyof Bixby.Models.ClientSlim = 'name';
      const payload: Bixby.Models.ClientSlim[] = Bixby.Utils.orderBy(
        (action.payload as Bixby.Models.ClientSlim[]) || [],
        keyofName
      );
      return {
        ...state,
        isLoading: false,
        clients: payload,
        error: undefined,
      };
    case CLIENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        clients: [],
      };
    case CLIENT_SUCCESS: {
      const currentClient = action.payload as Bixby.Models.Client | undefined;
      return {
        ...state,
        isLoading: false,
        currentClient,
        clientUsers: undefined,
        error: undefined,
      };
    }
    case CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        currentClient: undefined,
        clientUsers: undefined,
      };
    case CREATE_CLIENT:
      return {
        ...state,
        isCreating: true,
        createError: undefined,
      };
    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        isCreating: false,
        createError: undefined,
      };
    case CREATE_CLIENT_FAILURE:
      return {
        ...state,
        isCreating: false,
        createError: action.payload as Bixby.Models.BixbyError,
      };
    case CLIENT_UPDATE_SUCCESS: {
      const updates = action.payload as ClientUpdateType;
      const applyUpdate = (item: Bixby.Models.Client) => {
        if (item.id === updates.id) {
          return { ...item, ...updates };
        }
        return item;
      };
      return {
        ...state,
        currentClient: state.currentClient && applyUpdate(state.currentClient),
      };
    }
    case CLIENT_UPDATE_FAILURE:
      return {
        ...state,
        error: action.payload as Bixby.Models.BixbyError,
      };
    case CLIENT_USERS_LOADING:
      return {
        ...state,
        clientUsersLoading: true,
        clientUsers: undefined,
      };
    case CLIENT_USERS_SUCCESS:
      return {
        ...state,
        clientUsersLoading: false,
        clientUsers: action.payload as Bixby.Models.UserSlim[],
      };
    case CLIENT_USERS_FAILURE:
      return {
        ...state,
        clientUsersLoading: false,
        clientUsers: undefined,
        error: action.payload as Bixby.Models.BixbyError,
      };
    default:
      return state;
  }
};

export default clientsReducer;
